import React from 'react';
import BreakdownAI from './components/BreakdownAI';

function App() {
  return (
    <div className="App">
      <BreakdownAI />
    </div>
  );
}

export default App;